
<div class="container rich-text-editor-container">
	<div class="content">
		<div [formGroup]="edform">
			<div class="editor" (click)="focusEditor($event)">
				<ngx-editor-menu [editor]="editor" [toolbar]="toolbar">
				</ngx-editor-menu>
				<ngx-editor [editor]="editor" formControlName="editorContent" >
				</ngx-editor>
			</div>
		</div>
</div>
</div>
